import { forwardRef } from "react";
import { SvgIcon, type SvgIconProps } from "@mui/material";

const FileCheck = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  return (
    <SvgIcon viewBox="0 0 32 32" ref={ref} {...props}>
      <path d="M19.2 0H6.4C4.64 0 3.216 1.44 3.216 3.2L3.2 28.8c0 1.76 1.424 3.2 3.184 3.2H25.6c1.76 0 3.2-1.44 3.2-3.2V9.6L19.2 0zm-1.6 11.2V2.4l8.8 8.8h-8.8zm7.634 5.294-11.685 11.24-5.855-5.632 2.063-1.971 3.792 3.648 9.633-9.257 2.052 1.974z"/>
    </SvgIcon>
  );
});

FileCheck.displayName = "FileCheck";

export default FileCheck;
